import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { PremiumExperienceType } from 'owa-premium-travel';
import { logUsage } from 'owa-analytics';
export default function postIRISService(contentId: String) {
    var irisURL = 'https://onerm.olsvc.com/api/v1/promo';
    var json = {
        Puid: getUserConfiguration().SessionSettings.EncryptedUserPuid,
        Locale: getUserConfiguration().SessionSettings.UserCulture,
        OWAContentId: contentId,
    };
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let requestInit: RequestInit = {
        method: 'Post',
        headers: headers,
        body: JSON.stringify(json),
    };
    // Check to not make the api call for enterprise users
    if (getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.ExoConsumer) {
        fetch(irisURL, requestInit).then(() => {
            if (contentId.trim() != '' && contentId != PremiumExperienceType.None.toString()) {
                logUsage(
                    'IRISApiParameters',
                    {
                        contentId: contentId.toString(),
                        locale: json.Locale.toString(),
                    },
                    {
                        isCore: true,
                    }
                );
            }
        });
    }
}
